import { api, attachAuthOptions } from '../../utils/api';

const HELP_REQUEST_ENDPOINT = '/help-requests/create_request/';

export async function sendHelpRequest() {
  return api.post(HELP_REQUEST_ENDPOINT, {}, attachAuthOptions());
}
